// アプリ内の各画面から参照するプロジェクト外部リンク。
// TOP フッターとキャンバス画面の 2 か所から同じ URL・同じ文言を指すため、定数をここへ寄せる
// （片方だけが古くなるのを防ぐ）。

/** GitLab リポジトリの URL。 */
export const PROJECT_REPOSITORY_URL = "https://git.common.sereca.cloud/osakabe/refinement-canvas";

/** リポジトリリンクのアクセシブル名。共通シェル AppFooter の既定と同じ文言にそろえる。 */
export const PROJECT_REPOSITORY_LINK_LABEL = "GitLab リポジトリ";

/** リポジトリリンクの title。共通シェル AppFooter の既定（`{label}を開く`）と同じ形にそろえる。 */
export const PROJECT_REPOSITORY_LINK_TITLE = `${PROJECT_REPOSITORY_LINK_LABEL}を開く`;
